import { isData } from "root/tools.js"

export default {
	init (aRelationName, aData) {
		if (!isData(aData) || !isData(aRelationName)) {
			return
		}

		while (this.model[aRelationName].length > 0) {
			this.model[aRelationName].pop()
		}

		aData.forEach(currVal => {
			this.model[aRelationName].push(currVal)
		}, this)
	},

	edit (aModel, aValue) {
		this[aModel].copy(aValue)
		this.visibleModal = 'edit' + aModel
	},

	delete (aModel, aValue) {
		this[aModel].copy(aValue)
		this.visibleModal = 'delete' + aModel
	},

	add (aModel) {
		window.scrollTo(0, 0)
		this[aModel].clear()
		this.visibleModal = 'add' + aModel
	},

	save (aModel) {
		this.visibleModal = ''
		this.$store.dispatch('saveRelation', { basis: this.model, relation: this[aModel] })
		.then(response => {
			this.$store.dispatch('loadRelation', {basis: this.model, relation: aModel})
			.then(data => {
				this.initRelation(aModel, data)
				this.$store.dispatch('updateModel', this.model)
			})
		})
	},

	saveNew (aModel, aModelName) {

	},

	confirmDelete (aModel) {
		this.visibleModal = ''
		this.$store.dispatch('deleteRelation', { basis: this.model, relation: this[aModel] })
		.then(response => {
	  		this.$store.dispatch('loadRelation', {basis: this.model, relation: aModel})
	  		.then(data => {
				this.initRelation(aModel, data)
				this.$store.dispatch('updateModel', this.model)
	  		})
		})
	}
}



// WEBPACK FOOTER //
// ./src/functions/relations.js